export const stringFieldsAreFilled = (values: string[]) =>
	values.every(Boolean);
